import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {concatMap, from, Observable, of, toArray} from 'rxjs';
import { catchError } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { MatSnackBar } from '@angular/material/snack-bar';


export interface GriddingPinRequest {
  lat: number;
  lng: number;
  fieldId: number;
  tenantId: number;
  pinTypeId: number;
  pinSampleGroupId: number;
  userId: number;
  description: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class SampleGroupService {
  private BASE_URL = environment.apiBaseUrl + 'pin-management';

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {}

  insertSampleGroup(name: string, tenantId: number, userId: number, isGrid: boolean, gridRotation?: number, gridSpacing?: number): Observable<any> {
    const body = {
      name,
      active: true,
      userId,
      tenantId,
      isGrid,
      gridRotation,
      gridSpacing
    };
    return this.http.post(this.BASE_URL + '/samplegroups', body);
  }

  insertGriddingPins(
      points: Array<{ position: { lat: number; lng: number }; title: string }>,
      pinSampleGroupId: number,
      fieldId: number,
      tenantId: number,
      userId: number
  ): Observable<any[]> {
    return from(points).pipe(
        concatMap((point) => {
          const body: GriddingPinRequest = {
            lat: point.position.lat,
            lng: point.position.lng,
            fieldId,
            tenantId,
            pinTypeId: 4,
            pinSampleGroupId,
            userId,
            description: 'soil',
            name: point.title,
          };

          return this.http.post(this.BASE_URL + '/pins/gridding/single', body).pipe(
              concatMap((res) => of({ success: true, pin: res, name: point.title })),
              catchError((err) => of({ success: false, error: err, name: point.title }))
          );
        }),
        toArray()
    );
  }

  exportSampleGroupAsExcel(sampleGroupId: number, tenantId: number | string): Observable<{ download_url: string }> {
    const dataManagementUrl = environment.apiBaseUrl + 'data-management';
    return this.http.post<{ download_url: string }>(
      `${dataManagementUrl}/export/sample-group/excel`,
      { sampleGroupId, tenantId }
    ).pipe(
      catchError((err) => {
        this.snackBar.open('Export failed — could not download Excel file.', 'close', { duration: 3000 });
        throw err;
      })
    );
  }

  exportSampleGroupAsShapefile(sampleGroupId: number, tenantId: number | string): Observable<{ download_url: string }> {
    const dataManagementUrl = environment.apiBaseUrl + 'data-management';
    return this.http.post<{ download_url: string }>(
      `${dataManagementUrl}/export/sample-group/shapefile`,
      { sampleGroupId, tenantId }
    ).pipe(
      catchError((err) => {
        this.snackBar.open('Export failed — could not download Shapefile.', 'close', { duration: 3000 });
        throw err;
      })
    );
  }
}